export const makeAliasesFromClassAndOrg = (user) => {
  const aliases = [...(user?.organization?.settings?.contentTagAliases ?? [])];

  const activeSchoolClasses = (user?.schoolStaff?.schoolClasses ?? []).filter(
    (schoolClass) => !schoolClass.archivedAt
  );

  aliases.push(
    ...activeSchoolClasses.flatMap((schoolClass) => schoolClass?.settings?.contentTagAliases ?? [])
  );

  return aliases;
};
